import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UtilService } from "../providers/util-service";
import { RolAssinantesService } from "../providers/rol-assinantes-service";
import { UsuarioService } from "../providers/usuario-service";
import { GestaoPcaService } from "../providers/gestao-pca-service";

declare var dtjava: any;

@Injectable()
export class AGORA {

  PCAAtiva: any;
  usuarioLogado: any;
  cpfLogado: any;
  isCGE: boolean;
  isJurisdicionado: boolean;

  public REGRA_ANO: any = [/[1-2]/, /\d/, /\d/, /\d/];
  public REGRA_CEP = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  public REGRA_CPF = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public REGRA_DATA = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public REGRA_TELEFONE = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  public REGRA_EMAIL = [/\^[A-Za-z0-9._%+-]\+/, '@', /[A-Za-z0-9.-]\+/, '.', /[A-Za-z]\{2,4}\$/];

  constructor(private utilService: UtilService,
    public rolAssinantesService: RolAssinantesService,
    public gestaoPcaService: GestaoPcaService,
    public usuarioService: UsuarioService) {

    this.PCAAtiva = this.gestaoPcaService.getPCA();
    this.cpfLogado = this.usuarioService.obtemUsuario().dadosUsuario[0].cpf;
    this.cpfLogado = this.formatarCpf(this.cpfLogado);
    this.isCGE = this.usuarioService.isCGE();
    this.isJurisdicionado = this.usuarioService.isJurisdicionado();

  }

  public assinarArquivosPecas(idPca: number, idModuloPca: number, idModulo: number, exercicio: number,
    idEntidade: number, idTipoEntidadeExercicio: number, idTipoDocumento: number, cpfParam: any, perfil: any): Observable<any> {
    let isCGE = this.isCGE;
    let dtjavaLocal = dtjava;
    let isJur = this.isJurisdicionado;
    let service = this.rolAssinantesService;

    let cpfComMascara = this.formatarCpf(cpfParam);
    let loginCPF = this.cpfLogado;

    let urlBase = this.utilService.urlBase;
    let perfilTratado = perfil.replace(")","").replace("(","");
    perfilTratado = this.retira_acentos(perfilTratado.replace(new RegExp(" ", "g"), "_"));
    
    let params = '{' +
      '"protocolo" : "' + this.utilService.protocolo + '",' +
      '"servidor" : "' + this.utilService.host + '",' +
      '"porta" : "' + this.utilService.porta + '",' +
      '"urlEnvioArquivo" : "/' + this.utilService.appBase + 'arquivo/assinar?idPca=' + idPca + '&#38;cpfAssinante=' + cpfComMascara + '&#38;perfil=' + perfilTratado + '&#38;idDocumento=' + '",' +
      '"urlGetArquivo": "/' + this.utilService.appBase + 'arquivo/download/inline/",' +
      '"idPca": "' + idPca + '",' +
      '"idModuloPca": "' + idModuloPca + '",' +
      '"idModulo": "' + idModulo + '",' +
      '"exercicio": "' + exercicio + '",' +
      '"idEntidade": "' + idEntidade + '",' +
      '"idTipoEntidadeExercicio": "' + idTipoEntidadeExercicio + '",' +
      '"idTipoDocumento": "' + idTipoDocumento + '",' +
      '"jsessionid": "C83A925D712A8C34A5E64C20B53D0B5B",' +
      '"cpf": "' + cpfParam + '",' +
      '"callbackfunction": "retornoAssinatura",' +
      '"messageFunction": "messageFuncion",' +
      '"usarCarimboDoTempo":"false",' +
      ' "codeapp": "0"' +
      '}';

      console.log(params);
    let paramB64 = this.b64EncodeUnicode(params).replace(/\//g, '_');

    return Observable.create(function (observer) {

      try {
        if (idPca == null || cpfParam == null) {
          observer.error("Informar todos os parametros!");
        }

        if (isCGE) {
          dtjavaLocal.launch({ url: urlBase + 'arquivo/pecas/gerarjnlp/' + paramB64 });
          observer.next("Assinatura iniciada com sucesso !!");
        } else {
          service.getRolAssinantes(idPca).subscribe(listaDados => {
            let isAssinante: boolean = false;
            listaDados.forEach(assinante => {
              if (assinante.nuCpf === loginCPF) {
                isAssinante = true;
              }
            });

            if (!isJur) {
              isAssinante = true;
            }

            if (isAssinante) {
              dtjavaLocal.launch({ url: urlBase + 'arquivo/pecas/gerarjnlp/' + paramB64 });
              observer.next("Assinatura iniciada com sucesso !!");
            } else {
              console.log("Usuário não encontrado no Rol de Assinantes !");
              observer.error("Usuário não encontrado no Rol de Assinantes !");
            }
          }, error => {
            console.log("ERRO AO LISTAR NO BANCO");
            observer.error("Usuário não encontrado no Rol de Assinantes !");
            console.log(error);
          });
        }
      } catch (error) {
        observer.error(error);
      }
    });

  }

  public assinarArquivos(idListParam: string, idPcaParam: any, cpfParam: any, perfil: any): Observable<any> {
    let isCGE = this.isCGE;
    let dtjavaLocal = dtjava;
    let isJur = this.isJurisdicionado;
    let service = this.rolAssinantesService;

    var idList = idListParam;
    let idPca = idPcaParam;
    let cpfComMascara = this.formatarCpf(cpfParam);
    let loginCPF = this.cpfLogado;

    let urlBase = this.utilService.urlBase;
    let perfilTratado = perfil.replace(")","").replace("(","");
    perfilTratado = this.retira_acentos(perfilTratado.replace(new RegExp(" ", "g"), "_"));
    
    console.log(isCGE);
    console.log("perfil tratado: " + perfilTratado);
    console.log(perfil.replace(")","").replace("(",""));
    
    let params = '{' +
      '"protocolo" : "' + this.utilService.protocolo + '",' +
      '"servidor" : "' + this.utilService.host + '",' +
      '"porta" : "' + this.utilService.porta + '",' +
      '"urlEnvioArquivo" : "/' + this.utilService.appBase + 'arquivo/assinar?idPca=' + idPca + '&#38;cpfAssinante=' + cpfComMascara + '&#38;perfil=' + perfilTratado + '&#38;idDocumento=' + '",'  +
      '"urlGetArquivo": "/' + this.utilService.appBase + 'arquivo/download/inline/",' +
      '"ids": "' + idList + '",' +
      '"jsessionid": "C83A925D712A8C34A5E64C20B53D0B5B",' +
      '"cpf": "' + cpfParam + '",' +
      '"callbackfunction": "retornoAssinatura",' +
      '"messageFunction": "messageFuncion",' +
      '"usarCarimboDoTempo":"false",' +
      ' "codeapp": "0"' +
      '}';

    let paramB64 = this.b64EncodeUnicode(params).replace(/\//g, '_');

    return Observable.create(function (observer) {

      try {
        if (idList == null || idPca == null || cpfParam == null) {
          console.log("Informar todos os parametros!");
          observer.error("Informar todos os parametros!");
        }

        if (isCGE) {
          dtjavaLocal.launch({ url: urlBase + 'arquivo/gerarjnlp/' + paramB64 });
          observer.next("Assinatura iniciada com sucesso !!");
        } else {
          service.getRolAssinantes(idPca).subscribe(listaDados => {
            let isAssinante: boolean = false;
            listaDados.forEach(assinante => {
              if (assinante.nuCpf === loginCPF) {
                isAssinante = true;
              }
            });

            if (!isJur) {
              isAssinante = true;
            }
            console.log(isAssinante);
            if (isAssinante) {
              dtjavaLocal.launch({ url: urlBase + 'arquivo/gerarjnlp/' + paramB64 });
              observer.next("Assinatura iniciada com sucesso !!");
            } else {
              console.log("Usuário não encontrado no Rol de Assinantes !");
              observer.error("Usuário não encontrado no Rol de Assinantes !");
            }
          }, error => {
            console.log("ERRO AO LISTAR NO BANCO");
            observer.error("Usuário não encontrado no Rol de Assinantes !");
            console.log(error);
          });
        }
      } catch (error) {
        observer.error(error);
      }
    });

  }

  public assinarArquivosEvidencia(idListParam: string, idPcaParam: any, cpfParam: any, perfil: any): Observable<any> {
    let isCGE = this.isCGE;
    let dtjavaLocal = dtjava;
    let isJur = this.isJurisdicionado;
    let service = this.rolAssinantesService;

    var idList = idListParam;
    let idPca = idPcaParam;
    let cpfComMascara = this.formatarCpf(cpfParam);
    let loginCPF = this.cpfLogado;

   
    let urlBase = this.utilService.urlBase;
    let perfilTratado = perfil.replace(")","").replace("(","");
    perfilTratado = this.retira_acentos(perfilTratado.replace(new RegExp(" ", "g"), "_"));

    let params = '{' +
      '"protocolo" : "' + this.utilService.protocolo + '",' +
      '"servidor" : "' + this.utilService.host + '",' +
      '"porta" : "' + this.utilService.porta + '",' +
      '"urlEnvioArquivo" : "/' + this.utilService.appBase + 'arquivo/evidencia/assinar?idPca=' + idPca + '&#38;cpfAssinante=' + cpfComMascara + '&#38;perfil=' + perfilTratado + '&#38;idDocumento=' + '",' +
      '"urlGetArquivo": "/' + this.utilService.appBase + 'arquivo/evidencia/download/inline/",' +
      '"ids": "' + idList + '",' +
      '"jsessionid": "C83A925D712A8C34A5E64C20B53D0B5B",' +
      '"cpf": "' + cpfParam + '",' +
      '"callbackfunction": "retornoAssinatura",' +
      '"messageFunction": "messageFuncion",' +
      '"usarCarimboDoTempo":"false",' +
      ' "codeapp": "0"' +
      '}';

    let paramB64 = this.b64EncodeUnicode(params).replace(/\//g, '_');

    return Observable.create(function (observer) {

      try {
        if (idList == null || idPca == null || cpfParam == null) {
          console.log("Informar todos os parametros!");
          observer.error("Informar todos os parametros!");
        }

        if (isCGE) {
          dtjavaLocal.launch({ url: urlBase + 'arquivo/evidencia/gerarjnlp/' + paramB64 });
          observer.next("Assinatura iniciada com sucesso !!");
        } else {
          service.getRolAssinantes(idPca).subscribe(listaDados => {
            let isAssinante: boolean = false;
            listaDados.forEach(assinante => {
              if (assinante.nuCpf === loginCPF) {
                isAssinante = true;
              }
            });

            if (!isJur) {
              isAssinante = true;
            }

            if (isAssinante) {
              dtjavaLocal.launch({ url: urlBase + 'arquivo/evidencia/gerarjnlp/' + paramB64 });
              observer.next("Assinatura iniciada com sucesso !!");
              service.getRolAssinantes(idPca).subscribe();
            } else {
              console.log("Usuário não encontrado no Rol de Assinantes !");
              observer.error("Usuário não encontrado no Rol de Assinantes !");
            }
          }, error => {
            console.log("ERRO AO LISTAR NO BANCO");
            observer.error("Usuário não encontrado no Rol de Assinantes !");
            console.log(error);
          });
        }
      } catch (error) {
        observer.error(error);
      }
    });

  }

  b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode(("0x" + p1) as any);
      }));
  }

  formatarCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  retira_acentos(str) {

    let com_acento = "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ";
    let sem_acento = "AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr";
    let novastr = "";
  
    for (let i = 0; i < str.length; i++) {
      let troca = false;
      for (let a = 0; a < com_acento.length; a++) {
        if (str.substr(i, 1) == com_acento.substr(a, 1)) {
          novastr += sem_acento.substr(a, 1);
          troca = true;
          break;
        }
      }
      if (troca == false) {
        novastr += str.substr(i, 1);
      }
    }
    
    return novastr;
  }  
}



// WEBPACK FOOTER //
// ./src/app/AGORA.ts